import styled, { css } from "styled-components";
import { device } from "../../../constants";
import { theme } from "../../../styles/theme";

export const Section = styled.section`
  background-color: var(--product-bg-overlay);
  overflow: hidden;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  
  .container-blog {
    width: 100%;
  }

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const BackgroundImage = styled.img`
  z-index: 0;
  pointer-events: none;
  user-select: none;
  object-fit: cover;
  margin-top: -90px;
  width: 100%;
  max-height: 392px;
  
  @media ${device.laptop} {
    position: absolute;
    top: 0;
    left: 0;
    width: 70%;
    height: 100%;
    margin-top: unset;
    max-height: unset;
  }
`;

export const Content = styled.div`
  position: relative;
  max-width: 690px;
  margin-inline: auto;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;

  .bar {
    margin-bottom: 16px;
  }

  @media ${device.laptop} {
    margin-inline: unset;
    margin-left: auto;

    .bar {
      margin-bottom: 24px;
    }
  }
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors["neutral-01"]};
  
  @media ${device.laptop} {
    font-size: 32px;
    line-height: 48px;
    letter-spacing: 0px;
  }
`;

export const Description = styled.p`
  font-size: 18px;
  line-height: 32px;

  color: ${({ theme }) => theme.colors["neutral-01"]};
  text-align: center;
  font-weight: 400;
  letter-spacing: 0px;
  margin-bottom: 40px;
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  
  @media ${device.laptop} {
    margin-bottom: 56px;
    max-width: 540px;
    font-size: 20px;
    line-height: 36px;
  }
`;

export const ResultsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  width: 100%;
  margin-top: 40px;
  
  @media ${device.laptop} {
    margin-top: unset;
    grid-template-columns: repeat(2, 1fr);
    max-width: 680px;
  }
`;

export const ResultBox = styled.div`
  border: 2px solid var(--product-color);
  padding: 24px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  
  @media ${device.laptop} {
    width: 320px;
  }
`;

export const Value = styled.span`
  font-weight: 700;
  color: var(--product-color);
  margin-bottom: 4px;
  font-size: 56px;
  line-height: 72px;
  letter-spacing: -1.12px;
  
  @media ${device.laptop} {
    font-size: 60px;
    line-height: 72px;
    letter-spacing: -1.2px;
  }
`;

export const Label = styled.span`
  text-align: center;
  color: #fff;
  font-weight: 600;
  letter-spacing: 0px;
  font-size: 18px;
  line-height: 28px;
  
  @media ${device.laptop} {
    font-size: 20px;
    line-height: 28px;
  }
`;
